import { createSlice } from '@reduxjs/toolkit';

const initState = {
    provinces: [],
    districts: [],
    tehsils: [],
    ucs: [],
};

export const generalOptionsSlice = createSlice({
    name: 'generalOptionsSlice',
    initialState: { ...initState },
    reducers: {
        setOptionState: (state, payload = true) => {
            state.data = payload.payload;
        },
        resetOptionState: (state) => {
            state.data = { ...initState };
        },
    },
})

export const { setOptionState, resetOptionState } = generalOptionsSlice.actions

export default generalOptionsSlice.reducer